import styled from 'styled-components'
import { heading } from 'styles/typography'
import mq from 'styles/mq'
import theme from 'styles/theme'
import SimpleSelect from 'components/form-field/simple-select'

export const SectionTitle = styled.h1`
  ${heading.l};
  max-width: 77rem;
  margin-bottom: 2rem;

  ${mq.medium} {
    margin-bottom: 0;
  }
`

export const ReviewsListHeader = styled.div`
  display: flex;
  flex-direction: column;

  padding-bottom: 2rem;
  border-bottom: 0.1rem solid ${theme.color.text.dark};

  ${mq.medium} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`

export const SortSelect = styled(SimpleSelect)`
  border-bottom: 0.2rem solid ${theme.color.text.dark};
  margin-bottom: 2rem;

  svg {
    color: ${theme.color.text.dark};
  }

  ${mq.medium} {
    max-width: 20rem;
    margin-bottom: 0;
  }
`

export const Collection = styled.div`
  padding-bottom: 3.2rem;

  ${mq.medium} {
    padding-bottom: 7.2rem;
  }
`